// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d319efe","667":"a998a414"}[chunkId] + ".chunk.js";
};